module.exports = __webpack_public_path__ + "img/food_original.fc58d64f.jpg";